export const sceneSelector = `
    vec3 sampleScene(float idx, vec3 rd, vec2 uv, float time) {
        if(idx<0.5) return scenePlasma(uv,time);
        else if(idx<1.5) return sceneTunnel(rd,time);
        else if(idx<2.5) return sceneSpheres(rd,time);
        else if(idx<3.5) return sceneStars(uv,time);
        else if(idx<4.5) return sceneMoire(uv,time);
        else if(idx<5.5) return sceneGrid(rd,time);
        else if(idx<6.5) return sceneGem(rd,time);
        else if(idx<7.5) return sceneBars(uv,time);
        else if(idx<8.5) return sceneVoxels(rd,time);
        else if(idx<9.5) return sceneAurora(rd,time);
        return vec3(0.0);
    }
`;
